import client from "../api/client";
export const getList = () => {
  return client('/api/representatives').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/representatives/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/representatives/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/representatives', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/representatives/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useRepresentativeService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
